// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../AppStyles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participants {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f8f8;
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;
}

.user-list {
  display: flex;
  gap: 5px;
  margin-top: 10px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid transparent;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.whiteboard-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #f8f8f8;
  overflow: hidden;
}

.pen-toolbar {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* Increased spacing */
  padding: 15px 20px;
  background-color: #f8f8f8;
  z-index: 10;
}

.pen-toolbar label {
  font-weight: bold;
  color: var(--buttons-hover);
  margin-bottom: 3px;
}

.pen-toolbar input[type="range"] {
  width: 150px;
}

.pen-toolbar button,
.pen-toolbar .MuiButton-root {
  background-color: var(--buttons);
  color: #fff;
}

.pen-toolbar .MuiButton-root:hover {
  background-color: var(--buttons-hover);
}

.whiteboard-container canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: crosshair;
  z-index: 1;
}

.top-right {
  position: absolute;
  top: 10px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
  z-index: 10;
  text-align: right;
}

.top-right .user-list {
  margin-top: 5px;
}

.top-right-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/WhiteBoardStyles.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["@import \"../AppStyles.css\";\n\n.participants {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f8f8f8;\n  padding: 5px 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.user-list {\n  display: flex;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: white;\n}\n\n.user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.whiteboard-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  background-color: #f8f8f8;\n  overflow: hidden;\n}\n\n.pen-toolbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  /* Increased spacing */\n  padding: 15px 20px;\n  background-color: #f8f8f8;\n  z-index: 10;\n}\n\n.pen-toolbar label {\n  font-weight: bold;\n  color: var(--buttons-hover);\n  margin-bottom: 3px;\n}\n\n.pen-toolbar input[type=\"range\"] {\n  width: 150px;\n}\n\n.pen-toolbar button,\n.pen-toolbar .MuiButton-root {\n  background-color: var(--buttons);\n  color: #fff;\n}\n\n.pen-toolbar .MuiButton-root:hover {\n  background-color: var(--buttons-hover);\n}\n\n.whiteboard-container canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: crosshair;\n  z-index: 1;\n}\n\n.top-right {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 15px;\n  z-index: 10;\n  text-align: right;\n}\n\n.top-right .user-list {\n  margin-top: 5px;\n}\n\n.top-right-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
